export default __webpack_public_path__ + "static/media/Immagine_9.039de3a9.jpg";